import React, { Suspense } from 'react';

import {
  FeatureNotificationEnum,
  useDismissFeatureNotification,
} from '@portals/api/ui';

import { ModalProps } from '../../components/Modals';
import { FEATURES_MAP } from './feature-notifications.constants';

export interface FeaturesNotificationsProps
  extends ModalProps<{ featureNotification: FeatureNotificationEnum }> {}

export function FeaturesNotifications({
  closeMe,
  data,
}: FeaturesNotificationsProps) {
  const FeatureNotificationModal = FEATURES_MAP[data.featureNotification];
  const dismissFeatureNotification = useDismissFeatureNotification();

  if (!FeatureNotificationModal) return null;

  const onClose = () => {
    dismissFeatureNotification.mutate({
      notification_name: data.featureNotification,
    });

    closeMe();
  };

  return (
    <Suspense fallback={null}>
      <FeatureNotificationModal onClose={onClose} />
    </Suspense>
  );
}
